import React from 'react';

import IconTIApp from '@components/Images/Rebranding/IconTIApp';
import ListenButton from '@components/ListenButton';
import EventCluster from '@components/pages/SubscribeTest/OfferSelection/Clusters/EventCluster';
import FeatureCluster from '@components/pages/SubscribeTest/OfferSelection/Clusters/FeatureCluster';
import TITVSection from '@components/pages/SubscribeTest/Variants/T/TITVSection';

const BenefitCluster = ({ latestTITVEpisodeID }: { latestTITVEpisodeID?: string }) => {
  return (
    <article className="relative flex w-full flex-col gap-80 sm:gap-112">
      <div className="grid grid-cols-1 gap-80 lg:grid-cols-2 lg:gap-x-48 lg:gap-y-112">
        <TITVSection
          className="flex flex-col justify-between pb-12"
          latestTITVEpisodeID={latestTITVEpisodeID}
        />
        <EventCluster />
      </div>
      <div className="flex w-full flex-col lg:flex-row">
        <FeatureCluster
          className="relative mb-32 border-0 border-b border-solid border-grayscale-gray pb-32 sm:mb-48 sm:pb-48 lg:bottom-auto lg:my-0 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-64"
          description="Stay ahead from anywhere. Our app delivers our latest tech and AI news, analysis and alerts—so you never miss what matters."
          imageElement={<IconTIApp height={80} width={80} />}
          title="The Information App"
        />
        <FeatureCluster
          className="lg:pl-64"
          description="Listen to our reporting wherever you are, with our new text-to-audio feature brings our in-depth articles to life, making it easy to stay informed."
          imageElement={
            <div className="pointer-events-none flex h-80 w-[116px] items-center justify-center">
              <ListenButton
                currentUser={null}
                isAudioActive={false}
                setIsAudioActive={() => {}}
                contentType={null}
              />
            </div>
          }
          smallText="Available for mobile and desktop"
          title="Listen to Our Articles"
        />
      </div>
    </article>
  );
};

export default BenefitCluster;
